export const locale = {
  GLOBAL: {
    Title: "بيامك لاند",
    PostalCode: "الرمز البريدي",
    postalCodes: "الرموز البريدية",
    selectedPostalCodes: "الرموز البريدية المختارة",
    MciNumberCount: "عدد أرقام هاتف همراه أوّل (MCI)",
    MtuNumberCount: "عدد أرقام إيرانسل (Irancell)",
    TotalCount: "العدد الإجمالي",
    Coefficient: "المعامل",
    Back: "رجوع",
  },
  ERRORS: {
    PhoneIsNotValid: "رقم الهاتف المدخل غير صحيح: مثال 09101234567",
    InvalidNumber: "الرقم المدخل غير صحيح",
    NoSelectedLineNumber: "يرجى اختيار خط المرسِل.",
    EmptyText: "يرجى إدخال نص الرسالة.",
    UnknownError: "خطأ غير معروف",
    TryAgain: "يرجى المحاولة مرة أخرى لاحقًا.",
    NoAccountCharge: "رصيد الحساب غير كافٍ",
    NoAccess: "ليس لديك صلاحية الوصول.",
    PleasebyeAPlane: "يرجى شراء باقة.",
    PleaseChargeYourAccount: "يرجى شحن حسابك.",
    AccessDenied: "تم رفض الوصول.",
    AccessDeniedDescription: "للمزيد من المعلومات، يرجى التواصل مع الدعم الفني",
    Error: "خطأ",
    InvalidText: "نص غير صالح",
    InvalidTextContainsLink:
      "الخطوط الخدمية فقط هي التي يمكن أن تحتوي على روابط.",
  },
  INFOS: {
    SuccessSentSms: "تم إرسال الرسالة بنجاح",
    SmsRequestInQueue: "ستُرسل رسالتك بعد موافقة الإدارة",
    SendData: "بيانات الإرسال",
    CheckData: "يرجى مراجعة البيانات أدناه والتأكيد عليها.",
  },
  TOBE: {
    to: "إلى ",
    from: "من ",
  },
  FORMS: {
    DestinationPhone: "رقم الهاتف المستقبِل",
    TestDestinationPhone: "رقم الهاتف التجريبي",
    SourceNumber: "رقم المرسِل",
    Text: "نص الرسالة",
    CharCount: "عدد الأحرف",
    FarsiCharCount: "عدد الأحرف الفارسية",
    EnglishCharCount: "عدد الأحرف الإنجليزية",
    Send: "إرسال",
    SendTime: "وقت الإرسال",
    SendTest: "إرسال تجريبي",
    SendToTestNumber: "إرسال إلى الرقم التجريبي",
    SmsCount: "عدد الرسائل",
    SmsLang: "لغة الرسالة",
    Add: "إضافة",
    FromFile: "إضافة من ملف",
    TestNumber: "الرقم التجريبي",
    Test: "اختبار",
    ServiceRelated: "خط خدمي",
    Price: "السعر",
    NumbersCount: "عدد الأرقام",
    NumbersCountToSend: "عدد المستقبلين",
    Search: "بحث",
    Title: "العنوان",
    RequestTime: "وقت الطلب",
    RequestInformation: "معلومات الطلب",
    CreateNewPhoneBook: "إنشاء دفتر هاتف جديد",
  },
  BUTTONS: {
    OK: "موافق",
    AccountCharge: "شحن الحساب",
    Reports: "التقارير",
    RemoveAll: "إزالة الكل",
    BuyAPlane: "شراء باقة",
    Accept: "قبول",
    Reject: "رفض",
    Yes: "نعم",
    No: "لا",
    Create: "إنشاء",
    New: "جديد",
    Save: "حفظ",
    Delete: "حذف",
    More: "المزيد",
    TryAgain: "إعادة المحاولة",
    Close: "إغلاق",
    RollBack: {
      back: "العودة إلى المستخدم السابق",
      goToMainUser: "العودة إلى المستخدم الرئيسي",
      CurrentUser: "المستخدم الحالي",
    },
  },
  DIALOGS: {
    Waiting: "الرجاء الانتظار",
    RejectItQuestion: "رفض؟",
    AcceptItQuestion: "قبول؟",
    Rejected: "تم الرفض",
    Accepted: "تم القبول",
    Error: "خطأ",
  },
  CONFIRM: {
    Delete: "هل أنت متأكد من الحذف؟",
    DeleteA: "هل أنت متأكد من حذف {a}؟",
    DeleteALL: "هل أنت متأكد من حذف الكل؟",
  },
  LANGUAGE: {
    English: "الإنجليزية",
    Persian: "الفارسية",
  },
  language: {
    selectAll: "اختر الكل",
    lang: {
      fa: "الفارسية",
      ar: "العربية",
      ar_ae: "العربية (الإمارات)",
      ar_iq: "العربية (العراق)",
      en_US: "الإنجليزية (أمريكا)",
      en_GB: "الإنجليزية (بريطانيا)",
      de: "الألمانية",
      fr: "الفرنسية",
      zh_CN: "الصينية المبسطة",
      zh_TW: "الصينية التقليدية",
      tr: "التركية",
      ru: "الروسية",
      hy: "الأرمنية",
    },
    only_manual_now: "في الوقت الحالي، الترجمة اليدوية فقط متاحة",
    ai_coming_soon: "ترجمة الذكاء الاصطناعي ستُفعَّل قريباً",
    got_it: "فهمت",
    origin_language: "اللغة الأصلية",
    target_languages: "اللغات المستهدفة",
    remove_all: "إزالة جميع اللغات",
    translation_method: "اختر طريقة الترجمة",
    manual_translation: "الترجمة اليدوية",
    ai_translation: "ترجمة الذكاء الاصطناعي",
    coming_soon: "قريباً",
    source_language_updated: "تم تحديث اللغة الأصلية",
    error_changing_source_language: "خطأ في تغيير اللغة الأصلية",
    source_language_created: "تم إنشاء لغة أصلية جديدة",
    languages_saved: "تم حفظ اللغات الجديدة",
    error_saving_languages: "خطأ في حفظ اللغات",
    error_loading_language: "خطأ في تحميل اللغة",
    languages_removed: "اللغات المحذوفة",
    new_languages_to_save: "لغات جديدة لحفظها",
    saved: "تم الحفظ",
    management_langs: "إدارة اللغات",
    add_langs: "إضافة لغة",
    change_language: "تغيير اللغة",
    visit_card: "بطاقة الزيارة",
    translate_to: "تُرجم إلى",
    main_language: "اللغة",
    no_languages_available: "لا توجد لغات متاحة",
    return_to_default: "العودة إلى اللغة الأصلية",
    translate: "ترجمة",
    changes_pending: "في انتظار تطبيق التغييرات",
    apply_changes: "تطبيق التغييرات",
    cancel_changes: "إلغاء",
  },

  LISTS: {
    NoData: "لا توجد بيانات",
    NoDataFound: "لم يتم العثور على بيانات",
    NoDataFoundFor: "لم يتم العثور على بيانات لـ {a}",
    NoPhoneNumber: "لم يتم العثور على رقم هاتف",
    NoPostalCode: "لم يتم العثور على رمز بريدي",
    AddANumber: "أضف رقمًا",
    City: "المدينة",
    AddedBefore: "مضاف مسبقًا",
  },
  PAGES: {
    SendSms: "إرسال الرسائل النصية",
    MapSms: "الإرسال عبر الخريطة",
    PhoneBook: "دفتر الهاتف",
  },
  MONETARY: {
    Rial: "ريال",
  },
  HINTS: {
    SendMessageTitle:
      "العنوان هو اسم اختياري يمكنك اختياره. يمكنك إعادة استخدام عناوين الرسائل المرسلة سابقًا لتعبئة النص تلقائيًا. العنوان لا يُرسل في الرسالة ويُستخدم لأغراض التقارير واقتراح الرسائل.",
    SendMessageTime:
      "وقت الإرسال هو الوقت الذي تدخل فيه الرسالة قائمة الإرسال. لاحظ أن الرسالة لن تُرسل إلا بعد موافقة الإدارة.",
    CreatePhoneBook:
      "سيُستخدم هذا الاسم عند إضافة الأرقام من دفتر الهاتف أثناء عملية الإرسال.",
  },
  TOASTS: {
    SuccessCreate: "تم الإنشاء بنجاح",
    FailedCreated: "فشل الإنشاء",
    SuccessDelete: "تم الحذف بنجاح",
    FailedDelete: "فشل الحذف",
    SuccessEdit: "تم التعديل بنجاح",
    FailedEdit: "فشل التعديل",
    AddedSuccess: "تمت الإضافة بنجاح",
    AddedFailed: "فشل الإضافة",
  },
  WALLET: {
    CustomCharge: "مبلغ مخصص",
    GateWay: "بوابة الدفع",
    Price: "المبلغ",
    Details: [
      "سيتم إضافة ضريبة ٩٪ إلى المبلغ المدخل.",
      "يرجى التأكد من المبلغ جيدًا، فالإيداعات غير قابلة للاسترداد.",
    ],
    noGateWay: "لم يتم تعيين بوابة دفع لك.",
    PriceNotInRange: "يجب أن يكون المبلغ بين {min} و {max} ريال.",
    Pay: "دفع",
    ErrorOnRedirectToGateWay: "خطأ أثناء التحويل إلى بوابة الدفع",
    ChargeWalletButtonDescription: "اضغط على زر + لشحن حسابك",
  },
  login: {
    phoneField: {
      placeholderIran: "ابدأ بـ 9 (مثال: +98 912 345 6789)",
      placeholderDefault: "أدخل رقم هاتفك",
      maxDigitsError: "الحد الأقصى {count} أرقام!",
      iranMustStartWith9: "رقم الجوال يجب أن يبدأ بـ 9 (مثل 912…)",
    },
    signup_button: "سجّل الآن!",
    forget_password_title: "نسيت كلمة المرور",
    register_title: "تسجيل مجاني",
    login_title: "تسجيل الدخول",
    back: "رجوع",
    username_label: "رقم الجوال / اسم المستخدم",
    otp_resend_button: "إعادة إرسال الرمز",
    password_label: "كلمة المرور",
    password_hint: "8 أحرف على الأقل",
    name_label: "الاسم الأول",
    name_rule: "3 أحرف على الأقل",
    lastname_label: "اسم العائلة",
    phone_label: "الهاتف المحمول",
    nid_label: "الرقم الوطني",
    parent_phone_label: "جوال المُعرّف (اختياري)",
    terms_and_conditions_message:
      "بالتسجيل فإنك توافق على شروط وأحكام ترمينال الإعلانات.",
    terms_and_conditions_link: "الشروط والأحكام",
    close: "إغلاق",
    forgot_password_link: "نسيت كلمة المرور؟",
    change_password: "تغيير كلمة المرور",
    register_button: "تسجيل",
    login_button: "دخول",
    login_with_google: "الدخول بحساب جوجل",
    login_with_sms: "الدخول عبر الرسائل النصية",
    login_with_password: "الدخول بكلمة المرور",
    already_registered: "مسجّل مسبقًا؟",
    login_here: "تسجيل الدخول",
    no_account: "ليس لديك حساب؟",
    signup_now: "سجّل الآن!",
    more_info: "معلومات إضافية",
    text_login: "دخول",
    text_register: "تسجيل",
    required_field: "هذا الحقل مطلوب.",
    min_8_char: "الحقل أقل من 8 أحرف",
    required: "هذا الحقل مطلوب",
    min_3_char: "3 أحرف على الأقل",
    max_50_char: "50 حرفًا كحد أقصى",
    no_internet: "غير متصل بالإنترنت",
    no_phone_entered: "لم تدخل رقم هاتف",
    otp_sent_successfully: "تم إرسال رمز التحقق بنجاح.",
    please_register_first: "يرجى التسجيل أولاً!",
    wait_3_min: "يرجى الانتظار 3 دقائق ثم المحاولة مجددًا.",
    login_successful: "تم تسجيل الدخول بنجاح",
    internet_connection_error: "مشكلة في الاتصال بالإنترنت!",
    agree_to_terms_error: "لم توافق على الشروط والأحكام!",
    otp_sent_successfully_register: "تم إرسال رمز التحقق بنجاح.",
    error: "خطأ",
    registration_nid_required_notice:
      "لحماية الأمان العالي ومنع الاحتيال والاستخدام السيء للنظام، إدخال الرقم الوطني إلزامي عند التسجيل في ترمينال الإعلانات.",
  },
  home: {
    title: "الرئيسية",
    selectSystem: "اختر النظام",
    yourPoints: "نقاطك",
    discountCodes: "أكواد الخصم",
    all: "الكل",
    discounts: "الخصومات",
    systemGuide: "دليل النظام",
    yourPointsDynamic: "نقاطك: {points}",
    confirm: "تأكيد",
    copy: "نسخ",
  },
  badges: {
    free: "مجاني",
    preRegister: "تسجيل مسبق",
    comingSoon: "قريبًا",
    testVersion: "نسخة تجريبية",
  },
  services: {
    qrLand: {
      title: "نظام كيو آر لاند",
      description: "إنشاء رموز QR ديناميكية",
      property: {
        0: "مراجعة واختيار نوع الإعلان والموقع",
        1: "مراجعة واختيار أنواع إعلانات السينما",
        2: "لا حاجة لدفع عمولة أو رسوم إضافية",
        3: "إدارة موحدة لجميع الإعلانات الموضوعة في السينما",
      },
    },
    payamak: {
      title: "نظام بيامك لاند",
      description: "إرسال رسائل ترويجية جملة",
      property: {
        0: "إرسال رسائل نصية جملة",
        1: "قاعدة بيانات أرقام محدثة",
        2: "إرسال رسائل إلى نادي العملاء",
        3: "التكامل مع جميع المواقع والبرامج",
      },
    },
    robot: {
      title: "نظام روبوت لاند",
      description: "إدارة جميع الأرقام والإعلانات واللوحات في وقت واحد",
      property: {
        0: "نشر إعلانات جملة ومجموعات",
        1: "إدارة الإعلانات بشكل تدريجي وذكي ومؤقت",
        2: "تأجير وإضافة أرقام غير محدودة لنشر الإعلانات",
        3: "تسجيل وإدارة جميع الإعلانات في وقت واحد",
      },
    },
    infoLand: {
      title: "إنفو لاند",
      description: "أكثر من 2500 قاعدة بيانات تجارية محدثة",
      property: {
        0: "جميع معلومات الأعمال متاحة",
        1: "مقسمة حسب المدن والمحافظات",
        2: "قاعدة بيانات تجارية وطنية",
        3: "إمكانية معاينة عينات من جميع القواعد",
      },
    },
    graphic: {
      title: "نظام جرافيك لاند",
      description: "خدمات التصميم الجرافيكي والفيديو كاملة",
      property: {
        0: "تصميم اللوجو والقرطاسية",
        1: "جميع خدمات الطباعة والتغليف",
        2: "تصميم الكتالوج والكتيّب والصندوق",
        3: "تصميم وطباعة البانرات بجميع الأحجام",
      },
    },
    bestWebLand: {
      title: "نظام بست ويب لاند",
      description: "تصميم المواقع ودعمها وتحسين محركات البحث",
      property: {
        0: "تحسين المحتوى لمحركات البحث",
        1: "تحسين خارج الصفحة",
        2: "تحسين تقني",
        3: "تحسين داخل الصفحة",
      },
    },
    onlineShop: {
      title: "منشئ المتجر الإلكتروني",
      description: "بضع نقرات فقط وأنت في العالم الرقمي",
      badge: "بيع بالعمولة",
      property: {
        0: "تحسين المحتوى لمحركات البحث",
        1: "تحسين خارج الصفحة",
        2: "تحسين تقني",
        3: "تحسين داخل الصفحة",
      },
    },
    social: {
      title: "الإعلانات على وسائل التواصل الاجتماعي",
      description: "مراجعة واختيار أفضل الصفحات والقنوات",
      property: {
        0: "مراجعة جميع الصفحات ذات الزيارات العالية",
        1: "إدارة موحدة لجميع الإعلانات المغطاة",
        2: "لا حاجة لدفع عمولة أو رسوم إضافية",
        3: "طلب الإعلانات أونلاين على الصفحات المختارة",
      },
    },
    billboard: {
      title: "تأجير اللوحات الإعلانية أونلاين",
      description: "اختيار اللوحات مباشرة وبدون وسطاء",
      property: {
        0: "مراجعة موقع ونوع اللوحة",
        1: "إدارة جميع اللوحات المغطاة",
        2: "الاتصال المباشر بمالكي اللوحات بدون وسطاء",
        3: "لا حاجة لدفع عمولة أو رسوم إضافية",
      },
    },
    internationalMedia: {
      title: "الإعلان في الإعلام الوطني",
      description: "مراجعة ووضع الإعلانات في التلفزيون والراديو",
      property: {
        0: "مراجعة واختيار أوقات البث",
        1: "مراجعة واختيار أنواع إعلانات التلفزيون",
        2: "مراجعة واختيار أنواع إعلانات الراديو",
        3: "مراجعة واختيار الإعلانات الخاصة بالبرامج",
      },
    },
    transport: {
      title: "الإعلان في أسطول النقل",
      description: "المطارات، محطات القطار، الحافلات والمترو",
      property: {
        0: "مراجعة واختيار نوع الإعلان والموقع",
        1: "مراجعة واختيار أنواع إعلانات المترو",
        2: "لا حاجة لدفع عمولة أو رسوم إضافية",
        3: "إدارة موحدة لجميع الإعلانات الموضوعة في المترو",
      },
    },
    cinema: {
      title: "الإعلانات في الوسائط المرئية",
      description: "إعلانات السينما ومواقع مشاركة الفيديو",
      property: {
        0: "مراجعة واختيار نوع الإعلان والموقع",
        1: "مراجعة واختيار أنواع إعلانات السينما",
        2: "لا حاجة لدفع عمولة أو رسوم إضافية",
        3: "إدارة موحدة لجميع الإعلانات الموضوعة في السينما",
      },
    },
    estate: {
      title: "نظام العقارات أونلاين",
      description: "إدارة الملفات والاستشاريين والعملاء",
      property: {
        0: "مراجعة واختيار نوع الإعلان والموقع",
        1: "مراجعة واختيار أنواع إعلانات السينما",
        2: "لا حاجة لدفع عمولة أو رسوم إضافية",
        3: "إدارة موحدة لجميع الإعلانات الموضوعة في السينما",
      },
    },
    AIGeneration: {
      title: "نظام الذكاء الاصطناعي",
      description: "توليد الصور، الشات بوت",
    },
    ShortLink: {
      title: "نظام الروابط المختصرة",
      description: "إنشاء روابط مختصرة",
    },
    customer: {
      title: "نظام إدارة العملاء أونلاين",
      description: "إدارة ودعم وخلق عملاء مخلصين",
      property: {
        0: "مراجعة واختيار نوع الإعلان والموقع",
        1: "مراجعة واختيار أنواع إعلانات السينما",
        2: "لا حاجة لدفع عمولة أو رسوم إضافية",
        3: "إدارة موحدة لجميع الإعلانات الموضوعة في السينما",
      },
    },
    internetBroadcasting: {
      title: "إدارة الإعلانات على الإنترنت",
      description: "إعلانات جوجل، الدفع لكل نقرة، المقالات المدعومة",
      property: {
        0: "مراجعة واختيار نوع الإعلان والموقع",
        1: "مراجعة واختيار أنواع إعلانات السينما",
        2: "لا حاجة لدفع عمولة أو رسوم إضافية",
        3: "إدارة موحدة لجميع الإعلانات الموضوعة في السينما",
      },
    },
    emailMarketing: {
      title: "نظام التسويق عبر البريد الإلكتروني",
      description: "إرسال رسائل ترويجية إلى جميع الأعمال في البلاد",
      property: {
        0: "مراجعة واختيار نوع الإعلان والموقع",
        1: "مراجعة واختيار أنواع إعلانات السينما",
        2: "لا حاجة لدفع عمولة أو رسوم إضافية",
        3: "إدارة موحدة لجميع الإعلانات الموضوعة في السينما",
      },
    },
    adsOnStudium: {
      title: "الإعلانات في الملاعب والمعارض",
      description: "وجود العلامة التجارية في المنشآت الكبرى",
      property: {
        0: "مراجعة واختيار نوع الإعلان والموقع",
        1: "مراجعة واختيار أنواع إعلانات السينما",
        2: "لا حاجة لدفع عمولة أو رسوم إضافية",
        3: "إدارة موحدة لجميع الإعلانات الموضوعة في السينما",
      },
    },
    bidOnline: {
      title: "نظام المزادات الشامل أونلاين",
      description: "إنشاء المزادات أونلاين والمشاركة فيها",
      property: {
        0: "مراجعة واختيار نوع الإعلان والموقع",
        1: "مراجعة واختيار أنواع إعلانات السينما",
        2: "لا حاجة لدفع عمولة أو رسوم إضافية",
        3: "إدارة موحدة لجميع الإعلانات الموضوعة في السينما",
      },
    },
    onlineTools: {
      title: "نظام الأدوات التجارية أونلاين",
      description: "جميع الأدوات المساعدة لأي نوع من الأعمال",
      property: {
        0: "مراجعة واختيار نوع الإعلان والموقع",
        1: "مراجعة واختيار أنواع إعلانات السينما",
        2: "لا حاجة لدفع عمولة أو رسوم إضافية",
        3: "إدارة موحدة لجميع الإعلانات الموضوعة في السينما",
      },
    },
    onlineLearn: {
      title: "نظام التدريب التجاري أونلاين",
      description: "مراجعة واختيار الدورات التدريبية المستهدفة",
      property: {
        0: "مراجعة واختيار نوع الإعلان والموقع",
        1: "مراجعة واختيار أنواع إعلانات السينما",
        2: "لا حاجة لدفع عمولة أو رسوم إضافية",
        3: "إدارة موحدة لجميع الإعلانات الموضوعة في السينما",
      },
    },
    cloud: {
      title: "شراء الاستضافة والدومين",
      description: "شراء الاستضافة والدومين والسيرفر",
      property: {
        0: "مراجعة واختيار نوع الإعلان والموقع",
        1: "مراجعة واختيار أنواع إعلانات السينما",
        2: "لا حاجة لدفع عمولة أو رسوم إضافية",
        3: "إدارة موحدة لجميع الإعلانات الموضوعة في السينما",
      },
    },
    QrlandShop: {
  title: "إدارة المتاجر الإلكترونية",
  description: "إدارة متكاملة للمنتجات والأسواق الإلكترونية والتسعير الذكي",
  property: {
    0: "مراقبة وإدارة شاملة للمنتجات",
    1: "إدارة خيارات المنتجات",
    2: "مراقبة الأسواق الإلكترونية وإدارتها",
    3: "استراتيجيات التسعير الذكي",
  },
},

  },
  "planning.title": "التخطيط",
  "tabs.reminder": "التذكيرات",
  "tabs.notes": "الملاحظات",
  "tabs.calendar": "التقويم",
  "notes.creationDate": "تاريخ الإنشاء",
  "common.save": "حفظ",
  "common.cancel": "إلغاء",
  "actions.quickActions": "إجراءات سريعة",
  "notes.writeMessage": "اكتب ملاحظة",
  "notes.titlePlaceholder": "عنوان الملاحظة",
  "notes.addNote": "إضافة ملاحظة",
  "notes.updatedSuccess": "تم تحديث الملاحظة بنجاح.",
  "notes.addedSuccess": "تمت إضافة الملاحظة بنجاح.",
  "common.deletedSuccess": "تم الحذف بنجاح",
  "common.confirmDelete": "هل أنت متأكد من الحذف؟",
  "news.title": "أخبار الموقع",
  "news.noNews": "لم يتم نشر أي خبر في الموقع.",
  "news.view": "عرض",
  "remember.add": "إنشاء تذكير",
  "remember.update": "تحديث التذكير",
  "remember.titleLabel": "العنوان",
  "remember.dateLabel": "تاريخ التذكير",
  "remember.confirmDelete": "هل أنت متأكد من الحذف؟",
  "remember.deleteSuccess": "تم حذف التذكير بنجاح.",
  "remember.createSuccess": "تم إنشاء تذكير جديد.",
  "remember.updateSuccess": "تم تحديث التذكير.",
  "points.receivedAwards": "المكافآت المستلمة",
  "points.pointsHistory": "سجل النقاط",
  "points.points": "النقاط",
  "points.discountTitle": "خصم روبوت لاند",
  "points.discountText": "لكل 500 نقطة",
  events: {
    title: "الأحداث",
    addEvent: "إضافة حدث",
    calendar: "التقويم الأساسي",
    close: "إغلاق",
    save: "حفظ",
    update: "تحديث",
    confirmDelete: "هل أنت متأكد من الحذف؟",
    successAdd: "تمت الإضافة بنجاح.",
    successDelete: "تم حذف الحدث بنجاح.",
    successUpdate: "تم التحديث بنجاح.",
    titleLabel: "العنوان",
    descriptionLabel: "الوصف",
    colorLabel: "اللون",
    removeAfterDrop: "إزالة بعد السحب",
    createEvent: "إنشاء حدث",
  },
  copySuccess: "تم النسخ بنجاح.",
  copyTextTitle: "نسخ النص",
  copiedTextTitle: "تم النسخ",
  ribbon: {
    new: "جديد",
  },
  coupons: [
    { text: "هذه القسيمة صالحة لمدة 3 أسابيع", title: "نص غير متكرر 20%" },
    { text: "هذه القسيمة صالحة لمدة أسبوعين", title: "تصميم الموقع 5%" },
    { text: "هذه القسيمة للاستخدام مرة واحدة فقط", title: "إدارة الصفحات 10%" },
    { text: "هذه القسيمة مفعّلة دائمًا لك", title: "التصميم الجرافيكي 5%" },
    { text: "هذه القسيمة للاستخدام مرة واحدة فقط", title: "الطباعة 2%" },
  ],
  userLinks: {
    profile: {
      title: "نظرة عامة",
      invitation: { title: "دعوة الأصدقاء" },
      info: { title: "المعلومات الشخصية" },
      edit: { title: "استكمال الملف الشخصي" },
      changePass: { title: "تغيير كلمة المرور" },
    },
  },
  profileLinks: {
    orders: "الطلبات",
    addresses: "العناوين",
  },
  customPage: {
    overview: "نظرة عامة",
    personalInfo: "المعلومات الشخصية",
    changePassword: "تغيير كلمة المرور",
    completeProfile: "استكمال الملف الشخصي",
    email: "البريد الإلكتروني",
    balance: "الرصيد",
    phone: "الهاتف",
    rial: "ريال",
  },
  widget12: {
    inviteFriends: "دعوة الأصدقاء",
    viewInvitedUsers: "عرض قائمة المستخدمين الذين دعوتهم",
    yourInviteCode: "كود دعوتك",
    createNewUser: "إنشاء مستخدم جديد",
    copyText: "نسخ",
    userCreatedSuccess: "تم إنشاء المستخدم الجديد بنجاح",
    notCreated: "لم يتم الإنشاء",
  },
  userInfo: {
    userInformation: "معلومات المستخدم",
    profilePicture: "الصورة الشخصية",
    allowedFileTypes: "أنواع الملفات المسموحة: png, jpg, jpeg.",
    profilePictureSize: "يجب أن تكون الصورة الشخصية مربعة (مثل 480×480).",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    username: "اسم المستخدم",
    phone: "رقم الهاتف",
    email: "البريد الإلكتروني",
    receiveSMS: "استقبال الرسائل النصية",
    smsCostNote: "بتفعيل هذا الخيار ستُخصم تكلفة إرسال الرسائل من رصيدك.",
    saveChanges: "حفظ التغييرات",
    profileUpdated: "تم تحديث ملفك الشخصي بنجاح.",
  },
  emailSettings: {
    completeProfile: "استكمال الملف الشخصي",
    completeProfileDesc: "استكمال المعلومات الشخصية أو معلومات المؤسسة",
    cancel: "إلغاء",
    update: "تحديث",
    save: "حفظ",
    selectPersonType: "اختَر نوع الشخصية؟",
    realPerson: "شخص طبيعي",
    legalPerson: "شخص معنوي (مؤسسة)",
    phone: "الهاتف المحمول",
    landline: "الهاتف الأرضي",
    fatherName: "اسم الأب",
    nationalCode: "الرقم الوطني",
    idNumber: "رقم الهوية",
    birthday: "تاريخ الميلاد",
    placeOfBirth: "مكان الولادة",
    postalCode: "الرمز البريدي",
    email: "البريد الإلكتروني",
    introduction: "كيف تعرّفت علينا",
    nationalCodePic: "صورة البطاقة الوطنية",
    plaque: "رقم اللوحة العقارية",
    address: "العنوان الكامل",
    companyName: "اسم الشركة / المتجر",
    registrationNumber: "رقم التسجيل",
    economicCode: "الرمز الاقتصادي",
    organizationIdentity: "الرقم الوطني للمؤسسة",
    companyType: "نوع الشركة",
    activity: "مجال النشاط",
    registrationAd: "صورة إعلان تسجيل الشركة",
    lastPublishedAd: "صورة آخر إعلان رسمي منشور",
    statute: "صورة النظام الأساسي للشركة",
    agentLetterPic: "صورة خطاب تعريف الوكيل",
    successMessage: "تم الحفظ بنجاح",
    errorSelectType: "يرجى اختيار أحد الخيارين.",
    rules: {
      companyName: "حقل اسم الشركة/المتجر مطلوب.",
      registrationNumber: "حقل رقم التسجيل مطلوب.",
      economicCode: "حقل الرمز الاقتصادي مطلوب.",
      organizationIdentity: "حقل الرقم الوطني للمؤسسة مطلوب.",
      registrationAd: "صورة إعلان تسجيل الشركة مطلوبة.",
      lastPublishedAd: "صورة آخر إعلان رسمي منشور مطلوبة.",
      telephone: "حقل رقم الهاتف الأرضي مطلوب.",
      fatherName: "حقل اسم الأب مطلوب.",
      nationalCode: "حقل الرقم الوطني مطلوب.",
      birthday: "حقل تاريخ الميلاد مطلوب.",
      idNumber: "حقل رقم الهوية مطلوب.",
      placeOfBirth: "حقل مكان الولادة مطلوب.",
      postalCode: "حقل الرمز البريدي مطلوب.",
      nationalCodePic: "صورة البطاقة الوطنية مطلوبة.",
      address: "حقل العنوان مطلوب.",
      plaque: "حقل رقم اللوحة العقارية مطلوب.",
    },
    companyTypes: {
      governmental: "حكومية",
      private: "خاصة",
      commonStock: "مساهمة عامة",
      specialStock: "مساهمة خاصة",
    },
  },
  changePassword: {
    title: "تغيير كلمة المرور",
    description: "تغيير كلمة مرور حسابك",
    cancel: "إلغاء",
    update: "تحديث",
    passwordInstructions: {
      forgotPassword:
        "إذا لم تكن قد حدّدت كلمة مرور من قبل، يمكنك النقر على «نسيت كلمة المرور».",
      passwordRequirements:
        "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل وتحتوي على أرقام وحروف إنجليزية كبيرة وصغيرة ورموز.",
      passwordPrivacy: "يرجى عدم مشاركة كلمة المرور مع الآخرين.",
      keyboardLanguage:
        "تأكد من أن لوحة المفاتيح مضبوطة على اللغة الإنجليزية عند إنشاء كلمة المرور.",
    },
    currentPassword: "كلمة المرور الحالية",
    newPassword: "كلمة المرور الجديدة",
    confirmNewPassword: "تأكيد كلمة المرور الجديدة",
    addOrForgotPassword: "إضافة أو نسيان كلمة المرور",
    changePasswordWithCode: "تغيير كلمة المرور بالرمز",
    close: "إغلاق",
    change: "تغيير",
    enterCode: "إدخال الرمز",
    successMessage: "تم تحديث كلمة المرور بنجاح",
    invalidCode: "الرمز غير صحيح.",
    tooManyAttempts: "محاولات كثيرة جدًا!",
    rules: {
      required: "هذا الحقل مطلوب.",
      min: "الحقل أقصر من 8 أحرف",
      equal: "كلمة المرور وتأكيدها غير متطابقين",
      number: "أدخل عدد الأرقام",
    },
  },
  router: {
    dashboard: "لوحة التحكم",
    contacts: "نادي العملاء",
    editContact: "تعديل العميل",
    createContact: "إنشاء عميل",
    customers: "قائمة العملاء",
    contactList: "مساعد الاتصال",
    messages: "الرسائل",
    messageCategories: "فئات الرسائل",
    oldTransactions: "المعاملات القديمة",
    yourTransactions: "معاملاتك",
    buyPanel: "شراء لوحة",
    permissions: "الصلاحيات",
    createPermission: "إنشاء صلاحية",
    invitations: "دعواتي",
    editUser: "تعديل المستخدم",
    userInformation: "عرض معلومات المستخدم",
    walletEdit: "تعديل معلومات محفظة المستخدم",
    userHistory: "سجل المستخدم",
    userNotificationsHistory: "سجل إشعارات المستخدم",
    notifications: "الإشعارات",
    createNotification: "إنشاء إشعار",
    editNotification: "تعديل الإشعار",
    adminNotifications: "إشعارات الإدارة",
    yourNotifications: "إشعاراتك",
    adminNotificationsList: "إشعارات الإدارة",
    tickets: "التذاكر",
    createTicket: "إنشاء تذكرة جديدة",
    editTicket: "تعديل التذكرة",
    departments: "الأقسام",
    createDepartment: "قسم جديد",
    editDepartment: "تعديل القسم",
    adminTickets: "إدارة التذاكر",
    discounts: "الخصومات",
    createDiscount: "إنشاء خصم",
    editDiscount: "تعديل الخصم",
    workReports: "تقارير العمل",
    createWorkReport: "إنشاء تقرير عمل",
    callMonitoring: "مراقبة المكالمات",
    adminWorkReports: "إدارة تقارير العمل",
    editWorkReport: "عرض وتعديل تقرير العمل",
    packProperties: "خصائص الباقات",
    createPackProperty: "إنشاء خاصية باقة",
    editPackProperty: "تعديل خاصية الباقة",
    panels: "اللوحات",
    createPanel: "إنشاء لوحة",
    editPanel: "تعديل اللوحة",
    transferRequests: "طلبات السحب",
    editTransferRequest: "تعديل طلب السحب",
    tariffs: "التعرفة",
    createTariff: "إنشاء تعرفة",
    editTariff: "تعديل التعرفة",
    requests: "الطلبات",
    viewUser: "عرض المستخدم",
    manageTransactions: "إدارة المعاملات",
    viewTransaction: "عرض المعاملة",
    manageConfigs: "إدارة الإعدادات",
    rbLandConfigs: "إدارة إعدادات روبوت لاند",
    editConfig: "تعديل الإعدادات",
    manageUsers: "إدارة المستخدمين",
    categories: "الفئات",
    createCategory: "إضافة فئة",
    editCategory: "تعديل الفئة",
    content: "المحتوى",
    createContent: "إضافة محتوى",
    editContent: "تعديل المحتوى",
    addUserGuide: "إضافة دليل المستخدم",
    editUserGuide: "تعديل دليل المستخدم",
    roles: "الأدوار",
    editRole: "تعديل الدور",
    createRole: "إضافة دور",
    permissionTitle: "الصلاحيات",
    paymentGateways: "بوابات الدفع",
    editPaymentGateway: "تعديل بوابات الدفع",
    campaigns: "الحملات",
    createCampaign: "إنشاء حملة",
    editCampaign: "تعديل معلومات الحملة",
    adminCustomers: "العملاء",
    createCustomer: "إنشاء عميل",
    editCustomerInfo: "تعديل معلومات العميل",
    referrerCustomers: "عملاء المُعرّف",
    customerHistory: "سجل العميل",
    userProfile: "ملف المستخدم",
    editProfile: "تعديل الملف الشخصي",
    inviteFriends: "دعوة الأصدقاء",
    personalInfo: "المعلومات الشخصية",
    editPersonalInfo: "تعديل المعلومات الشخصية",
    changePassword: "تغيير كلمة المرور",
    newWallet: "محفظة جديدة",
  },
  profileView: {
    email: "البريد الإلكتروني",
    balance: "الرصيد",
    personType: "نوع الشخصية",
    currency: "ريال",
    unknown: "----",
  },
  panelInfoProfile: {
    panelTitle: "لديك لوحة {title} صالحة لمدة {days} يومًا.",
    buyOrRenew: "لشراء اللوحة أو تجديدها، انقر على الزر أدناه.",
    buyPanel: "شراء لوحة",
    percentage: "%",
  },
  profileSetting: {
    cardTitle: "إعدادات الملف الشخصي",
    changePasswordTitle: "تغيير كلمة مرور تسجيل الدخول",
    changePasswordSubtitle: "تغيير كلمة مرور حسابك.",
    alertMessage:
      "إذا لم تكن قد أدخلت كلمة مرور من قبل، فعّل خيار «تعيين كلمة مرور».",
    currentPasswordLabel: "كلمة المرور الحالية",
    setPasswordLabel: "تعيين كلمة مرور",
    addPassword: "إضافة كلمة مرور",
    newPasswordLabel: "كلمة المرور الجديدة",
    repeatPasswordLabel: "إعادة كلمة المرور",
    saveChanges: "حفظ التغييرات",
    currentPasswordPlaceholder: "كلمة المرور الحالية",
    newPasswordPlaceholder: "كلمة المرور الجديدة",
    repeatPasswordPlaceholder: "إعادة كلمة المرور",
  },
  profileOrders: {
    cardTitle: "الطلبات",
    openOrders: "الطلبات المفتوحة ({count})",
    closedOrders: "الطلبات المغلقة ({count})",
    noOrders: "لم تقم بإجراء أي طلبات بعد",
  },
  personalInformation: {
    cardTitle: "معلومات الحساب الشخصي",
    cardSubtitle: "تحديث معلوماتك الشخصية.",
    cancel: "إلغاء",
    update: "تحديث",
    yourInfo: "معلوماتك",
    profilePicture: "الصورة الشخصية",
    allowedFileTypes: "أنواع الملفات المسموحة: png، jpg، jpeg.",
    pictureSize: "يجب أن تكون الصورة الشخصية مربعة (مثال: 480 × 480).",
    name: "الاسم الأول",
    lastName: "اسم العائلة",
    username: "اسم المستخدم",
    receiveSMS: "استقبال الرسائل النصية",
    smsCostNote: "بتفعيل هذا الخيار ستُخصم تكلفة إرسال الرسائل من رصيدك.",
    phoneNumber: "رقم الجوال",
    phonePlaceholder: "رقم الجوال",
    email: "البريد الإلكتروني",
    emailPlaceholder: "البريد الإلكتروني",
    emailPrivacy: "لن نشارك بريدك الإلكتروني مع أحد أبدًا.",
    successMessage: "تم تحديث ملفك الشخصي بنجاح.",
  },
  userInfoForm: {
    companyName: "اسم الشركة / المتجر",
    registrationNumber: "رقم التسجيل",
    economicCode: "الرمز الاقتصادي",
    organizationIdentity: "الرقم الوطني للمؤسسة",
    companyType: "نوع الشركة",
    activity: "مجال النشاط",
    registrationAd: "صورة إعلان تسجيل الشركة",
    lastPublishedAd: "صورة آخر إعلان رسمي منشور",
    statute: "صورة النظام الأساسي للشركة",
    argentLetterPic: "صورة خطاب تعريف الوكيل",
    phone: "الهاتف المحمول",
    telephone: "الهاتف الأرضي",
    fatherName: "اسم الأب",
    nationalCode: "الرقم الوطني",
    id: "رقم الهوية",
    birthday: "تاريخ الميلاد",
    placeBirthday: "مكان الولادة",
    postalCode: "الرمز البريدي",
    email: "البريد الإلكتروني",
    introduction: "كيف تعرّفت علينا",
    nationalCodePic: "صورة البطاقة الوطنية",
    plaque: "رقم اللوحة العقارية",
    address: "العنوان الكامل",
    companyTypes: {
      governmental: "حكومية",
      private: "خاصة",
      common_stock: "مساهمة عامة",
      special_stock: "مساهمة خاصة",
    },
    rules: {
      companyName: "حقل اسم الشركة/المتجر مطلوب.",
      registration_number: "حقل رقم التسجيل مطلوب.",
      economic_code: "حقل الرمز الاقتصادي مطلوب.",
      organization_identity: "حقل الرقم الوطني للمؤسسة مطلوب.",
      registration_ad: "صورة إعلان تسجيل الشركة مطلوبة.",
      last_published_ad: "صورة آخر إعلان رسمي منشور مطلوبة.",
      telephone: "حقل رقم الهاتف الأرضي مطلوب.",
      fatherName: "حقل اسم الأب مطلوب.",
      nationalCode: "حقل الرقم الوطني مطلوب.",
      id: "حقل رقم الهوية مطلوب.",
      birthday: "حقل تاريخ الميلاد مطلوب.",
      placeBirthday: "حقل مكان الولادة مطلوب.",
      postalCode: "حقل الرمز البريدي مطلوب.",
      nationalCodePic: "صورة البطاقة الوطنية مطلوبة.",
      address: "حقل العنوان مطلوب.",
      plaque: "حقل رقم اللوحة العقارية مطلوب.",
    },
  },
  createUserForm: {
    name: "الاسم الأول",
    lastName: "اسم العائلة",
    nid: "الرقم الوطني",
    phone: "الهاتف المحمول",
    create: "إنشاء",
    errors: {
      nameRequired: "الاسم الأول مطلوب!",
      lastNameRequired: "اسم العائلة مطلوب!",
      nidRequired: "الرقم الوطني مطلوب!",
      phoneRequired: "رقم الجوال مطلوب!",
    },
  },
  lastView: {
    cardTitle: "آخر زياراتك",
    cardSubtitle: "آخر صفحات قمت بزيارتها",
    tableHeaders: {
      page: "الصفحة",
      address: "العنوان",
      enterDate: "تاريخ الدخول",
      leaveDate: "تاريخ الخروج",
      timeSpent: "الوقت المستغرق",
    },
    viewAll: "عرض الكل",
    timeUnit: "دقيقة",
    pages: {
      home: "الرئيسية",
      panels: "اللوحات",
      profile: "استكمال الملف الشخصي",
    },
  },
walletWidget: {
  title: "المعاملات الأخيرة",
  balanceLabel: "رصيدك:",
  viewTransactions: "عرض المعاملات",
  transactionTypes: {
    withdraw: "سحب",
    deposit: "إيداع",
    charge: "شحن المحفظة",
    refund: "استرداد",
    default: "معاملة",
    adminCharge: "تعديل بواسطة المسؤول",
    agency: "عمولة الوكالة",
  },
},
  panelWidget: {
    title: "لديك لوحة {title} صالحة لمدة {days} يومًا.",
    renewPrompt: "لشراء اللوحة أو تجديدها، انقر على الزر أدناه.",
    buyPanel: "شراء لوحة",
    percentage: "{value}٪",
    infinity: "∞",
    days: "{count} يوم",
  },
  component: {
    title: "المستخدمون الذين دعوتهم",
    columns: {
      row: "الصف",
      name: "الاسم الأول",
      family: "اسم العائلة",
      username: "اسم المستخدم",
      phone: "رقم الجوال",
      created_at: "تاريخ الانضمام",
      actions: "الإجراءات",
    },
    unknown: "غير معروف",
    error: "خطأ",
    breadcrumb: "المستخدمون المدعوون",
  },
  table: {
    itemsPerPage: "عدد الصفوف في الصفحة",
    pageText: "عرض {0} إلى {1} من أصل {2} مدخلة",
    prevText: "السابق",
    nextText: "التالي",
    noDataText: "لا توجد بيانات متاحة",
    search: "بحث",
  },
  UserHistory: {
    title: "سجل المستخدم",
    add_history: "إضافة سجل جديد",
    send_message: "إرسال رسالة",
    close: "إغلاق",
    save: "حفظ",
    cancel: "إلغاء",
    new_history_dialog_title: "إضافة سجل جديد",
    send_message_dialog_title: "إرسال رسالة",
    negotiations: "المفاوضات التي تمت",
    follow_up: "بنود المتابعة للاتصال القادم",
    success_history: "تم تسجيل السجل بنجاح.",
    success_message: "تم إرسال الرسالة بنجاح.",
    columns: {
      id: "المعرف",
      title: "العنوان",
      status: "المرحلة",
      current_time_date: "تاريخ آخر اتصال",
      current_time_hour: "وقت آخر اتصال",
      next_time_date: "تاريخ الاتصال القادم",
      next_time_hour: "وقت الاتصال القادم",
      user_id: "وكيل الدعم",
      actions: "الإجراءات",
    },
    table: {
      itemsPerPage: "عدد الصفوف في الصفحة",
      pageText: "عرض {0} إلى {1} من أصل {2} مدخلة",
      prevText: "السابق",
      nextText: "التالي",
      noDataText: "لا توجد بيانات متاحة",
      search: "بحث",
    },
    form: {
      title: "العنوان",
      status: "المرحلة",
      current_time: "تاريخ آخر اتصال",
      description: "الوصف",
      next_time: "تاريخ الاتصال القادم",
      pursue_text: "متابعة الاتصال القادم",
      category: "اختر الفئة",
      message_title: "عنوان الرسالة",
    },
  },
  newUserTransactions: {
    userWallet: "محفظة المستخدم",
    transactionList: "قائمة المعاملات",
    userTransactions: "معاملات المستخدم",
    terminal: "الترمينال",
    liveSms: "الرسائل الحية",
    realEstateNews: "آخر أخبار ديوار",
    rial: "ريال",
    row: "الصف",
    uniqueId: "المعرف",
    amount: "المبلغ",
    time: "الوقت",
    createdAt: "التاريخ",
    description: "الوصف الإضافي",
    type: "نوع المعاملة",
    product_description: "الوصف",
    serviceId: "اسم الخدمة",
    balanceAfter: "الرصيد بعد العملية",
    perPage: "العدد",
    search: "بحث",
    balance: "الرصيد",
    transactionListTooltip: "قائمة المعاملات",
    panelLogin: "تسجيل دخول اللوحة",
    history: "السجل",
    error: {
      terminalWallet: "خطأ في تحميل محفظة الترمينال",
    },
    transactionType: "نوع المعاملة",
    service: "الخدمة",
    dateFrom: "من تاريخ",
    dateTo: "إلى تاريخ",
    oldWallet: "المحفظة القديمة",
    depositReceipt: "إيصال الإيداع",
    showReceipt: "عرض الإيصال",
    transactionTypes: {
      online: "أونلاين",
      admin: "من الإدارة",
      refund: "تصحيحي",
      agency: "وكالة",
      withdraw: "سحب",
      deposit: "إيداع",
      adminCharge: "معاملة إدارية",
      charge: "شحن المحفظة",
      refund: "استرداد",
    },
    error: {
      imageLoad: "خطأ في تحميل الصورة!",
    },
  },
  buyPanel: {
    alert: {
      choosePanel: "يرجى اختيار نوع اللوحة بعناية!",
    },
    dialog: {
      title: "شراء لوحة",
      confirmPurchase: "هل أنت متأكد من شراء لوحة {title}؟",
      discountCodeLabel: "رمز الخصم",
      discountCodePlaceholder: "أدخل رمز الخصم",
      applyDiscount: "تطبيق الرمز",
      purchase: "شراء",
      iHaveDiscount: "لدي رمز خصم",
    },
    toast: {
      discountApplied: "تم تطبيق رمز الخصم بنجاح!",
      purchaseSuccess: "تم شراء الباقة بنجاح",
      error: "حدث خطأ: {message}",
      unauthorized: "يرجى تسجيل الدخول أولاً",
      validationError: "خطأ في التحقق: {message}",
    },
    currency: "ريال",
  },
  panelCard: {
    rial: "ريال",
    days: "يوم",
    buyPanel: "شراء لوحة",
  },
  cons: {
    title: "اختر الإيموجي",
  },
  cons1: {
    title: "النص الافتراضي",
  },
  MENUS: {
    AD_TERMINAL_SYSTEM: "المنظومة الكبرى لترمينال الإعلانات",
  },
};
